import {ReportData} from "../../../reports/report.data";
import {collection, field} from "@fedeltapointofsale/data-client";
import {SellableReportSelectionData} from "../../../catalogue/sellable/controls/sellable-report-selection-control.component";

export class ProductSaleAuditReportData extends ReportData<ProductSaleAuditReportData> {
    @collection() groupBy: string[] = ["none"];
    @field exclusive: boolean = true;
    @collection(SellableReportSelectionData) sellables: SellableReportSelectionData[];
    @field reportType: string = "SIMPLE";
}
